import React, { useState, useEffect, useRef } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import { GripVertical, Eye, EyeOff } from 'lucide-react';

export default function AdminLayoutManager() {
  const { settings, reload } = useSiteSettings();
  const [layout, setLayout] = useState([]);
  const [saving, setSaving] = useState(false);
  const dragIdx = useRef(null);

  useEffect(() => {
    setLayout(settings.portalLayout?.length ? settings.portalLayout : []);
  }, [settings]);

  // ── Drag reorder (native HTML5) ──
  const onDragStart = (i) => { dragIdx.current = i; };
  const onDragOver = (e, i) => {
    e.preventDefault();
    if (dragIdx.current === null || dragIdx.current === i) return;
    setLayout(prev => {
      const next = [...prev];
      const [moved] = next.splice(dragIdx.current, 1);
      next.splice(i, 0, moved);
      dragIdx.current = i;
      return next;
    });
  };
  const onDragEnd = () => { dragIdx.current = null; };

  const toggleVisible = (key) => setLayout(prev => prev.map(l => l.key === key ? { ...l, visible: !(l.visible !== false) } : l));

  const save = async () => {
    setSaving(true);
    try {
      await API.patch('/settings', { portalLayout: layout });
      toast.success('Tata letak portal tersimpan');
      reload && reload();
    } catch (err) { toast.error(err.response?.data?.message || 'Gagal menyimpan'); }
    finally { setSaving(false); }
  };

  return (
    <DashboardLayout title="Tata Letak Portal" subtitle="Atur urutan dan tampil/sembunyi section halaman utama dengan menyeret">
      <div className="ki-card" style={{ marginBottom: 24 }}>
        <div className="section-title" style={{ marginBottom: 6 }}>Urutan Section Portal</div>
        <p style={{ fontSize: 13, color: 'var(--ki-text-muted)', marginBottom: 16 }}>
          Seret kartu untuk mengubah urutan tampil di halaman utama. Klik ikon mata untuk menyembunyikan section.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {layout.map((item, i) => (
            <div
              key={item.key}
              draggable
              onDragStart={() => onDragStart(i)}
              onDragOver={(e) => onDragOver(e, i)}
              onDragEnd={onDragEnd}
              style={{
                display: 'flex', alignItems: 'center', gap: 14, padding: '16px 18px',
                background: 'var(--in-card)', border: '1px solid var(--ki-border)', borderRadius: 12,
                cursor: 'grab', opacity: item.visible === false ? 0.55 : 1,
                boxShadow: 'var(--in-shadow)',
              }}
            >
              <GripVertical size={18} style={{ color: 'var(--ki-text-faint)', flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{item.label || item.key}</div>
                <div style={{ fontSize: 12, color: 'var(--ki-text-faint)' }}>Posisi #{i + 1}{item.visible === false ? ' · Disembunyikan' : ''}</div>
              </div>
              <button onClick={() => toggleVisible(item.key)} className="btn btn-icon btn-ghost"
                title={item.visible === false ? 'Tampilkan' : 'Sembunyikan'}>
                {item.visible === false ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button className="btn btn-primary" disabled={saving} onClick={save}>{saving ? 'Menyimpan...' : 'Simpan Tata Letak'}</button>
      </div>
    </DashboardLayout>
  );
}
